import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import classNames from 'classnames'
import { mq, px2rem, hiDPIpx } from '@utils'

import cssClasses from '@constants/cssClasses'
import {
  requestFilters as requestFiltersGallery,
  setSecondaryMenus as setSecondaryMenusGallery,
  setCurrentShowTab as setCurrentShowTabGallery
} from '@stores/catalog'
import CommonHeader from './CommonHeader'

const OtmModuleHeader = props => (
  <section className={classNames(props.className, cssClasses.CMS_MODULE, 'CatalogListTitle')}>
    <CommonHeader
      user={props.user}
      query={props.query}
      entities={props.catalog}
      requestFilters={props.requestFiltersGallery}
      setSecondaryMenus={props.setSecondaryMenusGallery}
      setCurrentShowTab={props.setCurrentShowTabGallery}
      clt_grp1_favorites={props.clt_grp1_favorites}
      clt_grp1_title={props.clt_grp1_title}
      clt_grp1_all_shows_label={props.clt_grp1_all_shows_label}
      secomComplement='Catalog-Favorite'
    />
  </section>
)

OtmModuleHeader.propTypes = {
  className: PropTypes.string,
  user: PropTypes.object,
  query: PropTypes.object,
  catalog: PropTypes.object,
  requestFiltersGallery: PropTypes.func,
  setSecondaryMenusGallery: PropTypes.func,
  setCurrentShowTabGallery: PropTypes.func,
  clt_grp1_favorites: PropTypes.string,
  clt_grp1_title: PropTypes.string,
  clt_grp1_all_shows_label: PropTypes.string
}

const ConnectedOtmModuleHeader = connect(
  ({ user, page, catalog }) => ({
    user,
    query: page.query,
    catalog
  }),
  {
    requestFiltersGallery,
    setSecondaryMenusGallery,
    setCurrentShowTabGallery
  }
)(OtmModuleHeader)

export default styled(ConnectedOtmModuleHeader)`
  &.CatalogListTitle.cms-module {
    z-index: 1;
    position: relative;

    &&&&&&&&&&&&& {
      margin-top: ${px2rem(60)} !important;
      ${mq.between('tablet', 'largestTablet')`
        margin-top: ${hiDPIpx(94)} !important;
      `}

      ${mq.lessThan('largestMobile')`
        margin-top: ${px2rem(94)} !important;
      `}
    }
  }
`